import http from "./http.service";
import SalesTaxConfigurationService from "../../modules/setup/sales-tax-configuration/SalesTaxConfigurationService";

class GeographicStructureHelper {
  static async getStatesByCountryCode(params) {
    const response = await SalesTaxConfigurationService.getStatesByCountryCode(params);
    if (response.success) {
      response.body = response.body.results ? response.body.results : response.body;
    }
    return response;
  }

  static async getCountiesByState(params) {
    const response = await SalesTaxConfigurationService.getCounties(params);
    if (response.success) {
      response.body = response.body.results ? response.body.results : response.body;
    }
    return response;
  }

  static async getCitiesByState(params) {
    const response = await SalesTaxConfigurationService.getCities(params);
    if (response.success) {
      response.body = response.body.results ? response.body.results : response.body;
    }
    return response;
  }
}

export {
  GeographicStructureHelper
};
